module.exports = __webpack_public_path__ + "img/collar buttons quantity.ce638306.png";